import "./blogPostStyle.css";

function BlogPost({ blog, light }) {
  return (
    <div className={light ? "lightBlog" : "darkBlog"}>
      <div className="blogTitle">
        <h1>{blog.title}</h1>
        <h2>
          <i>by {blog.author}</i>
        </h2>
        <p className="">{blog.datePosted}</p>
      </div>
      <div className="imageContainer">
        <img src={blog.imageSrc} alt={blog.imageAlt} />
        <p>
          <i>{blog.imageAlt}</i>
        </p>
      </div>
      <div>
        <p>{blog.content}</p>
      </div>
    </div>
  );
}

export default BlogPost;
